import React from 'react';
import styled from '@emotion/styled';
import { Button } from '../../common';
import signupBg from '../../assets/images/signup_bg.png';
// Styled components for response screens
const ErrorPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
`;

const ResponseFullScreen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-width: 100vw;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  text-align: center;
  background: #ffffff;
  margin: 0;
  padding: 0;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: url(${signupBg});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    opacity: 0.1;
    pointer-events: none;
  }

  > * {
    position: relative;
    z-index: 2;
  }
`;
const ResponseTitle = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: #000;
  margin-bottom: 24px;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.8);
  padding: 0 20px;
  max-width: 600px;

  @media (max-width: 768px) {
    font-size: 28px;
    padding: 0 16px;
  }
`;

const ResponseDescription = styled.p`
  font-size: 20px;
  line-height: 1.6;
  color: #000;
  margin-bottom: 36px;
  max-width: 600px;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.8);
  padding: 0 40px;

  @media (max-width: 768px) {
    font-size: 16px;
    padding: 0 24px;
    margin-bottom: 24px;
  }
`;

const DashboardButton = styled.button`
  background-color: #9cc31c;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 16px 36px;
  font-size: 20px;
  cursor: pointer;
  font-weight: 600;
  margin-bottom: 36px;
  width: fit-content;
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);

  &:hover {
    background-color: #8ab219;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    padding: 14px 28px;
    font-size: 18px;
    margin-bottom: 24px;
  }
`;

const ContactInfo = styled.p`
  font-size: 18px;
  color: #000;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.8);

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const ContactLink = styled.a`
  color: #0078d4;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

// Reject Screen Component
export const RejectScreen = () => (
  <ErrorPageContainer>
    <ResponseFullScreen>
      <ResponseTitle>Sorry, this study is not a good match</ResponseTitle>
      <ResponseDescription>
        It seems you may not be eligible for this study. We would love to you in another study. Please download app to check further new studies. Hope to see you soon.
      </ResponseDescription>
      <ContactInfo>
        For Help: <ContactLink href="mailto:contact@explorastory.in">contact@explorastory.in</ContactLink>
      </ContactInfo>
    </ResponseFullScreen>
  </ErrorPageContainer>
);

// Form Completed Screen Component
export const FormCompletedScreen = () => (
  <ErrorPageContainer>
    <ResponseFullScreen>
      <ResponseTitle>All Done!</ResponseTitle>
      <ResponseDescription>
        Thanks for completing the study.  we appreciate your input! You will receive your incentive in a few days.
        <br />
        Meanwhile download the app for new studies.
      </ResponseDescription>
      <ContactInfo>
        For Help: <ContactLink href="mailto:contact@explorastory.in">contact@explorastory.in</ContactLink>
      </ContactInfo>
    </ResponseFullScreen>
  </ErrorPageContainer>
);

// Application Status Screen Component
export const ApplicationStatusScreen = () => (
  <ErrorPageContainer>
    <ResponseFullScreen>
      <ResponseTitle>Your eligibility is further under review.</ResponseTitle>
      <ResponseDescription>
        Thank you for applying. Meanwhile download the app for new studies.
      </ResponseDescription>
      <ContactInfo>
        For Help: <ContactLink href="mailto:contact@explorastory.in">contact@explorastory.in</ContactLink>
      </ContactInfo>
    </ResponseFullScreen>
  </ErrorPageContainer>
);

// Error Submission Screen Component
export const ErrorSubmissionScreen = ({ errorMessage }) => (
  <ErrorPageContainer>
    <ResponseFullScreen>
      <ResponseTitle>Error Submitting Response</ResponseTitle>
      <ResponseDescription>
        {'An error occurred while submitting your responses. Please try again later.'}
      </ResponseDescription>
      <ContactInfo>
        For Help: <ContactLink href="mailto:contact@explorastory.in">contact@explorastory.in</ContactLink>
      </ContactInfo>
    </ResponseFullScreen>
  </ErrorPageContainer>
);

// Main Response Screen Component that handles all types
export const ResponseScreen = ({ responseType, responseMessage }) => {
  if (responseType === 'reject' && responseMessage === 'Sorry unable to sign you up') {
    return <RejectScreen />;
  }
  
  // Handle generic error messages (statusCode -1 cases)
  if (responseType === 'reject' && responseMessage && responseMessage !== 'Sorry unable to sign you up') {
    return <ErrorSubmissionScreen errorMessage={responseMessage} />;
  }
  
  if (responseType === 'complete' && responseMessage === 'Thank you! Your form has been submitted successfully.') {
    return <FormCompletedScreen />;
  }
  
  if (responseType === 'complete' && responseMessage === 'Thank you! We will notify you on your apllication status') {
    return <ApplicationStatusScreen />;
  }
  
  return null;
};

export default ResponseScreen;
